import CategoriesItemLamps from "./CategoriesItemLamps";
import Footer from "../Footer";
import Newsletter from "../Newsletter";

function Lamps() {
  return (
    <>
      <CategoriesItemLamps />
      <Newsletter />
      <Footer />
    </>
  );
}

export default Lamps;
